require('lib/browser_required')('lib/jquery')

const $ = require('jquery')
const filters = require('lib/jquery_ajax_prefilter')

// initialize jquery prefilters
filters.initialize()

// window, html, body shortcuts
$.window = $(window)
$.document = $(document)
$.html = $('html')
$.head = $('head')
$.body = $('body')
$.layers = $('.layers')

// expose window.$ because some plugins and third-party libs expect it
window.$ = window.jQuery = $

module.exports = $
